<template>
    <rkm-area
        no-margin-top
        title="Informações administrativas"
    >
        <rkm-row>
            <rkm-col cols="2">
                <Item
                    :get-value="() => item.desfecho"
                    label="Desfecho"
                />
            </rkm-col>

            <rkm-col cols="4">
                <Item
                    :get-value="() => item.lotacao.profissional.nome"
                    label="Profissional"
                />
            </rkm-col>

            <rkm-col cols="4">
                <Item
                    :get-value="() => `${item.lotacao.ocupacao.codigo} - ${item.lotacao.ocupacao.nome}`"
                    label="CBO"
                />
            </rkm-col>

            <rkm-col cols="2">
                <Item
                    :get-value="() => item.centroCusto.setor.nome"
                    label="Setor"
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

export default {
    components: {Item},
    props: {
        item: {type: Object, required: true},
    },
}
</script>